import { render, staticRenderFns } from "./UserProfileNewUserWallet.vue?vue&type=template&id=bd35e5c4"
import script from "./UserProfileNewUserWallet.vue?vue&type=script&lang=js"
export * from "./UserProfileNewUserWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports